<napa-input-with-options wlcmInput [formGroup]="form">
  <input placeholder="Type here" napaIwoInput formControlName="value" [imask]="maskOptions" />

  <wlcm-select napaIwoSelect formControlName="option" [options]="unitOptions()" placeholder="unit"></wlcm-select>
</napa-input-with-options>
